// extracted by mini-css-extract-plugin
export var actionText = "_ok-4";
export var container = "_ok-0";
export var leftSection = "_ok-1";
export var rightSection = "_ok-2";
export var settingsButton = "_ok-6";
export var settingsIcon = "_ok-7";
export var shortcut = "_ok-5";
export var shortcutGroup = "_ok-3";